import * as React from "react";
import Login from "../Pages/Login";
import { AuthProtected, ProtectedRoute } from "./ProtectedRoute.js";
import DashboardLayout from "../Pages/Dashboard/DashboardLayout";
import Earnings from "../Pages/Dashboard/Earnings/Earnings";
import Dashboard from "../Pages/Dashboard/Dashboard.jsx";
import Users from "../Pages/Users/Users/Users.jsx";
import Drivers from "../Pages/Users/Drivers/Drivers.jsx";
import Store from "../Pages/Users/Store/Store.jsx";
import DeliveryReview from "../Pages/Dashboard/Order/Review/DeliveryReview.jsx";
import OrderReview from "../Pages/Dashboard/Order/Review/OrderReview.jsx";
import Orders from "../Pages/Eanings/Orders/Orders.jsx";
import DeliveryMan from "../Pages/Eanings/DeliveryMan/DeliveryMan.jsx";
import EarningStore from "../Pages/Eanings/EarningsStore/Store.jsx";
import WalletHistory from "../Pages/Eanings/WalletHistory/WalletHistory.jsx";
import WalletRequest from "../Pages/Eanings/WalletRequest/WalletRequest.jsx";
import TransactionHistory from "../Pages/Eanings/TransactionHistory/TransactionHistory.jsx";
import Category from "../Pages/Menu/Category/Category.jsx";
import Item from "../Pages/Menu/Item/Item.jsx";
import ModifierCategory from "../Pages/Menu/Modifier/ModifierCategory.jsx";
import CourierService from "../Pages/Menu/Courier/CourierService.jsx";
import StoreLocation from "../Pages/Dashboard/MapView/StoreLocation/StoreLocation.jsx";
import DeliveryManLocation from "../Pages/Dashboard/MapView/DeliveryManLocation/DeliveryManLocation.jsx";
import DeliveryManTracking from "../Pages/Dashboard/MapView/DeliveryManTracking/DeliveryManTracking.jsx";
import Delivery from "../Pages/Dashboard/DeliveryInfo/Delivery/Delivery.jsx";
import Admin from "../Pages/Settings/BasicSetting/admin/admin.jsx";
import Language from "../Pages/Settings/BasicSetting/Language/Language.jsx";
import Document from "../Pages/Settings/BasicSetting/Document/Document.jsx";
import Settings from "../Pages/Dashboard/Settings/Settings.jsx";
import SettingMaster from "../Pages/Settings/Master/SettingMaster.jsx";
import TaxMaster from "../Pages/Settings/Master/TaxMaster/TaxMaster.jsx";
import AllOrder from "../Pages/Dashboard/Order/AllOrder.jsx";
import PendingOrder from "../Pages/Dashboard/Order/PendingOrder.jsx";
import AcceptedOrder from "../Pages/Dashboard/Order/AcceptedOrder.jsx";
import DeliveredOrder from "../Pages/Dashboard/Order/DeliveredOrder.jsx";
import DispatchPage from "../Pages/Dashboard/Order/DispatchPage/DispatchPage.jsx";
import ReturnOrder from "../Pages/Dashboard/Order/ReturnOrder.jsx";
import CancelOrder from "../Pages/Dashboard/Order/CancelOrder.jsx";
import ReplaceOrder from "../Pages/Dashboard/Order/ReplaceOrder.jsx";
import CountryCity from "../Pages/Dashboard/DeliveryInfo/CountryCity/CountryCity.jsx";
import DeliveryFees from "../Pages/Dashboard/DeliveryInfo/DeliveryFees/DeliveryFees.jsx";
import CancellationReason from "../Pages/Settings/Template/CancellationReason/CancellationReason.jsx";
import Promocode from "../Pages/Discount/Promocode.jsx";
import ForgetPassword from "../Components/ForgetPassword/ForgetPassword.jsx";
import VerifyOtp from "../Components/ForgetPassword/VerifyOtp.jsx";
import LoginCard from "../Components/Login/LoginCard.jsx";
import ResetPassword from "../Components/ForgetPassword/ResetPassword.jsx";
import ProductDetails from "../Pages/ProductDetails/ProductDetails.jsx";
import ProductReview from "../Pages/Dashboard/Order/History/ProductReview.jsx";
import StoreReviews from "../Pages/Dashboard/Order/History/StoreReviews.jsx";
import PrivacyAndTerm from "../Pages/Settings/Template/PrivacyPolicyAndTerm/PrivacyAndTerm.jsx";
import SMSTemplate from "../Pages/Settings/Template/PrivacyPolicyAndTerm/SMSTemplate.jsx";
import EmailTemplate from "../Pages/Settings/Template/PrivacyPolicyAndTerm/EmailTemplate.jsx";
import PromocodeReferral from "../Pages/PromotionManagement/Refferal/PromocodeReferral.jsx";
import AUCategory from "../Pages/ApproveUnapprove/Category/AUCategory.jsx";
import AUSubcategory from "../Pages/ApproveUnapprove/Subcategory/AUSubcategory.jsx";
import AUItem from "../Pages/ApproveUnapprove/Item/AUItem.jsx";
import Subcategory from "../Pages/Menu/SubCategory/Subcategory.jsx";
import AUAdvertisement from "../Pages/ApproveUnapprove/Advertisement/AUAdvertisement.jsx";
import RolesPermission from "../Pages/Settings/RolesAndPermissions/RolesPermission/RolesPermission.jsx";
import PromoManagement from "../Pages/PromotionManagement/PromoManagement/PromoManagement.jsx";
import RoleMaster from "../Pages/Settings/RolesAndPermissions/RoleMaster/RoleMaster.jsx";
import ComponentTypes from "../Pages/Settings/RolesAndPermissions/ComponentTypes/ComponentTypes.jsx";
import Components from "../Pages/Settings/RolesAndPermissions/Component/Components.jsx";
import Permissions from "../Pages/Settings/RolesAndPermissions/Permissions/Permissions.jsx";
import VehicalType from "../Pages/Settings/Master/VehicalType/VehicalType.jsx";
import AUPromocode from "../Pages/ApproveUnapprove/AUPromocode/AUPromocode.jsx";
import RegionType from "../Pages/Settings/Master/DeliveryRegionMaster/RegionType.jsx";
import DeliveryType from "../Pages/Settings/Master/DeliveryType/DeliveryType.jsx";
import AUUser from "../Pages/ApproveUnapprove/user/AUUser.jsx";
import TaxRegime from "../Pages/Settings/Master/TaxRegime/TaxRegime.jsx";
import Promosale from "../Pages/Discount/Promosale.jsx";
import AUPromosale from "../Pages/ApproveUnapprove/AUPromocode/AUPromosale.jsx";
import UserList from "../Pages/Settings/RolesAndPermissions/AddUsers/UserList.jsx";
import MultiLevelApproval from "../Pages/Settings/RolesAndPermissions/MultiLevelApproval/MultiLevelApproval.jsx";
import FinancingFunding from "../Pages/FinancingFunding/FinancingFunding.jsx"
import BulkChat from "../Pages/BulkChat/BulkChat.jsx";
import Resources from "../Pages/Menu/Youtube/Resources.jsx";
import CreateForm from "../Components/DynamicForm/CreateForm.jsx";
import UnitOfMaster from "../Pages/Settings/Master/UnitOfMeasurementMaster/UnitOfMaster.jsx";
import PackageMaster from "../Pages/Settings/Master/PackageMaster/Packagemaster.jsx";
import PreSuggestion from "../Pages/PreSuggestions/PreSuggestion.jsx";
import FinanceReview from "../Pages/Dashboard/Order/History/FinanceReview.jsx";
import AboutUs from "../Pages/Settings/Template/AboutUs.jsx";
import TicketManagement from "../Pages/TicketManagement/TicketManagement.jsx";
import VendorProductEarnings from "../Pages/Eanings/EarningsStore/VendorEarnings.jsx";

export const approvalRoutes=[
  {
    meta: {
      name: "Approve and Unapprove Category",
      entityType:"Category",
      link: "approve-unapprove/category",
    },
    path: "approve-unapprove/category",   
    element: <AUCategory meta={[]} />,
  },
  {
    meta: {
      name: "Approve Unapprove Subcategory",
      entityType:"SubCategory",
      link: "approve-unapprove/subcategory",
    },
    path: "approve-unapprove/subcategory",
    element: <AUSubcategory meta={[]} />,
  },
  {
    meta: {
      name: "Approve Unapprove Item",
      entityType:"Product",
      link: "approve-unapprove/item",
    },
    path: "approve-unapprove/item",
    element: <AUItem meta={[]} />,
  },
  {
    meta: {
      name: "Approve Unapprove Advertise",
      entityType:"Advertisement",
      link: "approve-unapprove/advertisement",
    },
    path: "approve-unapprove/advertisement",
    element: <AUAdvertisement meta={[]} />,
  },
  {
    meta: {
      name: "Promocode Approval",
      entityType:"PromoCode",
      link: "approve-unapprove/promocode-approval",
    },
    path: "approve-unapprove/promocode-approval",
    element: <AUPromocode meta={[]} />,
  },
  {
    meta: {
      name: "Sales Approval",
      entityType:"Sale",
      link: "approve-unapprove/promosale-approval",
    },
    path: "approve-unapprove/sale-approval",
    element: <AUPromosale meta={[]} />,
  },
  {
    meta: {
      name: "Vendor Approval",
      entityType:"User",
      link: "approve-unapprove/user-approval",
    },
    path: "approve-unapprove/user-approval",
    element: <AUUser meta={[]} />,
  },
]

export const AfterLoginRoutes = [
  {
    meta: {
      name: "Dashboard",
      link: "dashboard",
    },

    path: "dashboard",
    element: <Dashboard meta={[]} />,
  },
  {
    meta: {
      name: "Earning",
      link: "earnings",
    },
    path: "earnings",
    element: <Earnings meta={[]} />,
  },
  {
    meta: {
      name: "Order",
      link: "earnings/order",
    },
    path: "earnings/order",
    element: <Orders meta={[]} />,
  },
  {
    meta: {
      name: "Education Resources",
      link: "menu/edu-resources",
    },
    path: "menu/edu-resources",
    element: <Resources/>,
  },
  {
    meta: {
      name: "Delivery Man",
      link: "earnings/deliveryman",
    },
    path: "earnings/deliveryman",
    element: <DeliveryMan meta={[]} />,
  },
  {
    meta: {
      name: "Earning Store",
      link: "earnings/store",
    },
    path: "earnings/store",
    element: <EarningStore meta={[]} />,
  },
  {
    meta: {
      name: "Wallet History",
      link: "earnings/wallet-history",
    },
    path: "earnings/wallet-history",
    element: <WalletHistory meta={[]} />,
  },
  {
    meta: {
      name: "Wallet Request",
      link: "earnings/wallet-request",
    },
    path: "earnings/wallet-request",
    element: <WalletRequest meta={[]} />,
  },
    {
    meta: {
      name: "Vendor Product Earnings",
      link: "earnings/store/:vendorId",
    },
    path: "earnings/store/:vendorId",
    element: <VendorProductEarnings meta={[]} />,
  },
  {
    meta: {
      name: "Transaction History",
      link: "earnings/transaction-history",
    },
    path: "earnings/transaction-history",
    element: <TransactionHistory meta={[]} />,
  },
  {
    meta: {
      name: "Menu Category",
      link: "menu/category",
    },
    path: "menu/category",
    element: <Category meta={[]} />,
  },
  {
    meta: {
      name: "Menu Item",
      link: "menu/item",
    },
    path: "menu/item",
    element: <Item meta={[]} />,
  },
  {
    meta: {
      name: "Item by ID",
      link: "menu/item/:id",
    },
    path: "menu/item/:id",
    element: <Item meta={[]} />,
  },
  {
    meta: {
      name: "Modifier Category",
      link: "menu/modifier-category",
    },
    path: "menu/modifier-category",
    element: <ModifierCategory meta={[]} />,
  },
  {
    meta: {
      name: "Menu Subcategory",
      link: "menu/subcategory",
    },
    path: "menu/subcategory",
    element: <Subcategory meta={[]} />,
  },
  {
    meta: {
      name: "Courier Service",
      link: "menu/courier-service",
    },
    path: "menu/courier-service",
    element: <CourierService meta={[]} />,
  },
  {
    meta: {
      name: "Pre Suggestion",
      link: "menu/pre-suggestions",
    },
    path: "menu/pre-suggestions",
    element: <PreSuggestion meta={[]} />,
  },
  // {
  //   path: "running-order/order",
  //   element: <Order meta={[]} />,
  // },
  // {
  //   path: "running-order/table-boking",
  //   element: <TableBooking meta={[]} />,
  // },
  // {
  //   path: "running-order/delivery-order",
  //   element: <DeliveryOrder meta={[]} />,
  // },
  // {
  //   path: "running-order/dispatch",
  //   element: <DispatchPage meta={[]} />,
  // },
  // {
  //   path: "history/history",
  //   element: <HistoryPage meta={[]} />,
  // },
  // {
  //   path: "history/review",
  //   element: <ReviewPage meta={[]} />,
  // },
  {
    meta: {
      name: "Store Reviews",
      link: "order/store-reviews",
    },
    path: "order/store-reviews",
    element: <StoreReviews meta={[]} />,
  },
  {
    meta: {
      name: "Product Reviews",
      link: "order/product-reviews",
    },
    path: "order/product-reviews",
    element: <ProductReview meta={[]} />,
  },
  {
    meta: {
      name: "Finance Reviews",
      link: "order/finance-reviews",
    },
    path: "order/finance-reviews",
    element: <FinanceReview meta={[]} />,
  },
  {
    meta: {
      name: "Product Reviews",
      link: "product-details/:productId",
    },
    path: "product-details/:productId",
    element: <ProductDetails meta={[]} />,
  },

  {
    meta: {
      name: "Order Review",
      link: "review/order-review",
    },
    path: "review/order-review",
    element: <OrderReview meta={[]} />,
  },
  {
    meta: {
      name: "Store Review",
      link: "review/delivery-review",
    },
    path: "review/delivery-review",
    element: <DeliveryReview meta={[]} />,
  },

  // new order template @start
  {
    meta: {
      name: "Order",
      link: "order/all-orders",
    },
    path: "order/all-orders",
    element: <AllOrder meta={[]} />,
  },
  {
    meta: {
      name: "Pending Order",
      link: "order/pending-orders",
    },
    path: "order/pending-orders",
    element: <PendingOrder meta={[]} />,
  },
  {
    meta: {
      name: "Accepted Order",
      link: "order/accepted-orders",
    },
    path: "order/accepted-orders",
    element: <AcceptedOrder meta={[]} />,
  },
  {
    meta: {
      name: "Delivered",
      link: "order/delivered-orders",
    },
    path: "order/delivered-orders",
    element: <DeliveredOrder meta={[]} />,
  },
   {
    meta: {
      name: "User Tickets",
      link: "ticket-management/customer-tickets",
    },
    path: "ticket-management/customer-tickets",
    element: <TicketManagement meta={[]} />,
  },
  {
    meta: {
      name: "User Tickets",
      link: "ticket-management/vendor-tickets",
    },
    path: "ticket-management/vendor-tickets",
    element: <TicketManagement meta={[]} />,
  },
  {
    meta: {
      name: "Return Order",
      link: "order/all-return-order",
    },
    path: "order/all-return-order",
    element: <ReturnOrder meta={[]} returnType={"RETURNED"}/>,
  },
  {
    meta: {
      name: "Return Order",
      link: "order/pending-return-order",
    },
    path: "order/pending-return-order",
    element: <ReturnOrder meta={[]} returnType={"RETURNED"}/>,
  },
  {
    meta: {
      name: "Return Order",
      link: "order/done-return-order",
    },
    path: "order/done-return-order",
    element: <ReturnOrder meta={[]} returnType={"RETURNED"}/>,
  },
  {
    meta: {
      name: "Cancel Order",
      link: "order/cancel-order",
    },
    path: "order/cancel-order",
    element: <CancelOrder meta={[]} />,
  },
  {
    meta: {
      name: "Replacement",
      link: "order/replacement",
    },
    path: "order/replacement",
    element: <ReplaceOrder meta={[]} />,
  },
  {
    meta: {
      name: "Dispatch",
      link: "order/dispatch",
    },
    path: "order/dispatch",
    element: <DispatchPage meta={[]} />,
  },
  // new order template @end
  {
    meta: {
      name: "Map View",
      link: "map-view/store-location",
    },
    path: "map-view/store-location",
    element: <StoreLocation meta={[]} />,
  },
  {
    meta: {
      name: "Delivery Man Location",
      link: "map-view/provider-location",
    },
    path: "map-view/provider-location",
    element: <DeliveryManLocation meta={[]} />,
  },
  {
    meta: {
      name: "Delivery Man Tracking",
      link: "map-view/delivery-man-tracking",
    },
    path: "map-view/delivery-man-tracking",
    element: <DeliveryManTracking meta={[]} />,
  },
  {
    meta: {
      name: "Users",
      link: "users/user",
    },
    path: "users/user",
    element: <Users meta={[]} />,
  },
  {
    meta: {
      name: "Funds Opportinuity",
      link: "menu/funding-opportunity",
    },
    path: "menu/funding-opportunity",
    element: <FinancingFunding meta={[]} />,
  },
  {
    meta: {
      name: "Deliveryman",
      link: "users/deliveryman",
    },
    path: "users/deliveryman",
    element: <Drivers meta={[]} />,
  },
  // {
  //   meta: {
  //     name: "Bulk Chat",
  //     link: "bulkchat/chats",
  //   },
  //   path: "bulkchat/chats",
  //   element: <BulkChat/>,
  // },
  {
    meta: {
      name: "User Store",
      link: "users/store",
    },
    path: "users/store",
    element: <Store meta={[]} />,
  },
  {
    meta: {
      name: "Delivery Info",
      link: "delivery-info/delivery",
    },
    path: "delivery-info/delivery",
    element: <Delivery meta={[]} />,
  },
  {
    meta: {
      name: "Country City",
      link: "delivery-info/country-city-info",
    },
    path: "delivery-info/country-city-info",
    element: <CountryCity meta={[]} />,
  },
  {
    meta: {
      name: "Delivery Fees",
      link: "delivery-info/delivery-fees",
    },
    path: "delivery-info/delivery-fees",
    element: <DeliveryFees meta={[]} />,
  },
  {
    meta: {
      name: "Promotion Management",
      link: "promotion-management/promocode",
    },
    path: "promotion-management/promocode",
    element: <Promocode meta={[]} />,
  },
  {
    meta: {
      name: "Promotion Management",
    },
    path: "promotion-management/promosale",
    element: <Promosale meta={[]} />,
  },
  {
    meta: {
      name: "Refferal",
      link: "promotion-management/referral",
    },
    path: "promotion-management/referral",
    element: <PromocodeReferral meta={[]} />,
  },
  {
    meta: {
      name: "Promotion Management Advertise",
      link: "promotion-management/advertisement",
    },
    path: "promotion-management/advertisement",
    element: <PromoManagement meta={[]} />,
  },

  {
    meta: {
      name: "Settings",
      link: "settings",
    },
    path: "settings",
    element: <Settings meta={[]} />,
  },
  {
    meta: {
      name: "Admin",
      link: "settings/basic-settings/admin",
    },
    path: "settings/basic-settings/admin",
    element: <Admin meta={[]} />,
  },
  {
    meta: {
      name: "Language",
      link: "settings/basic-settings/language",
    },
    path: "settings/basic-settings/language",
    element: <Language meta={[]} />,
  },
  {
    meta: {
      name: "Document",
      link: "settings/basic-settings/document",
    },
    path: "settings/basic-settings/document",
    element: <Document meta={[]} />,
  },
  {
    meta: {
      name: "Multi Level Approvals",
      link: "settings/roles-and-permissions/multi-level-approval",
    },
    path: "settings/roles-and-permissions/multi-level-approval",
    element: <MultiLevelApproval meta={[]} />,
  },
  {
    meta: {
      name: "User Role",
      link: "settings/roles-and-permissions/user-role",
    },
    path: "settings/roles-and-permissions/user-role",
    element: <RoleMaster meta={[]} />,
  },
  {
    meta: {
      name: "Add User",
      link: "settings/roles-and-permissions/add-user",
    },
    path: "settings/roles-and-permissions/add-user",
    element: <UserList meta={[]} />,
  },
  {
    meta: {
      name: "Component Type",
      link: "settings/roles-and-permissions/component-type",
    },
    path: "settings/roles-and-permissions/component-type",
    element: <ComponentTypes meta={[]} />,
  },
  {
    meta: {
      name: "Components",
      link: "settings/roles-and-permissions/components",
    },
    path: "settings/roles-and-permissions/components",
    element: <Components meta={[]} />,
  },
  {
    meta: {
      name: "Permissions",
      link: "settings/roles-and-permissions/permissions",
    },
    path: "settings/roles-and-permissions/permissions",
    element: <Permissions meta={[]} />,
  },
  {
    meta: {
      name: "Assign Permissions",
      link: "settings/roles-and-permissions/assign-permission",
    },
    path: "settings/roles-and-permissions/assign-permission",
    element: <RolesPermission meta={[]} />,
  },
  // {
  //   meta: {
  //     name: "Dynamic Form Settings",
  //     link: "settings/master/setting-master",
  //   },
  //   path: "settings/master/setting-master",
  //   element: <CreateForm meta={[]} />,
  // }, 
  {
    meta: {
      name: "Tax Master",
      link: "settings/master/tax-master",
    },
    path: "settings/master/tax-master",
    element: <TaxMaster meta={[]} />,
  },
  {
    meta: {
      name: "Unit Master",
      link: "settings/master/unit-master",
    },
    path: "settings/master/unit-master",
    element: <UnitOfMaster meta={[]} />,
  },
  {
    meta: {
      name: "Package Master",
      link: "settings/master/package-master",
    },
    path: "settings/master/package-master",
    element: <PackageMaster meta={[]} />,
  },
  {
    meta: {
      name: "Tax Regime",
      link: "settings/master/tax-regime",
    },
    path: "settings/master/tax-regime",
    element: <TaxRegime meta={[]} />,
  },
  {
    meta: {
      name: "Vehical Type",
      link: "settings/master/vehical-type",
    },
    path: "settings/master/vehical-type",
    element: <VehicalType meta={[]} />,
  },
  {
    meta: {
      name: "Region Type",
      link: "settings/master/region-type",
    },
    path: "settings/master/region-type",
    element: <RegionType meta={[]} />,
  },
  {
    meta: {
      name: "Delivery Type",
      link: "settings/master/delivery-type",
    },
    path: "settings/master/delivery-type",
    element: <DeliveryType meta={[]} />,
  },
  {
    meta: {
      name: "Delivery Type",
      link: "settings/master/delivery-fees",
    },
    path: "settings/master/delivery-fees",
    element: <DeliveryFees meta={[]} />,
  },
  {
    meta: {
      name: "Cancellation Reson",
      link: "settings/template/cancelation",
    },
    path: "settings/template/cancelation",
    element: <CancellationReason meta={[]} />,
  },
  {
    meta: {
      name: "About Us",
      link: "settings/template/aboutUs",
    },
    path: "settings/template/aboutUs",
    element: <AboutUs meta={[]} />,
  },
  {
    meta: {
      name: "Email",
      link: "settings/template/emails",
    },
    path: "settings/template/emails",
    element: <EmailTemplate meta={[]} />,
  },
  {
    meta: {
      name: "Privacy and Terms",
      link: "settings/template/privacy-and-terms",
    },
    path: "settings/template/privacy-and-terms",
    element: <PrivacyAndTerm meta={[]} />,
  },
  {
    meta: {
      name: "SMS",
      link: "settings/template/sms",
    },
    path: "settings/template/sms",
    element: <SMSTemplate meta={[]} />,
  },
  ...approvalRoutes
];    

export const publicRoutes=[
  {
    path: "/",
    element: (
      <AuthProtected>
        <Login meta={[]} />
      </AuthProtected>
    ),
    children: [
      {
        path: "/",
        element: <LoginCard meta={[]} />,
      },
      {
        path: "forget-password",
        element: <ForgetPassword meta={[]} />,
      },
      {
        path: "verfy-otp",
        element: <VerifyOtp meta={[]} />,
      },
      {
        path: "reset-password",
        element: <ResetPassword meta={[]} />,
      },
    ],
  },
]

export const ProtectedRouters={
  path: "app",
  element: (
    <ProtectedRoute>
      <DashboardLayout meta={[]} />
    </ProtectedRoute>
  ),
  children: null,
}
